import React from 'react';
import moment from 'moment';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';

interface Props {
  title: string;
  timeStamp: string | null;
  buttonText?: string;
  onClick?: (ev: any) => void;
}

export const AccountStatusTooltip = ({ title, timeStamp, buttonText, onClick }: Props) => {
  return (
    <Box>
      <Text fontSize="small" color="white">
        {title}
      </Text>
      {timeStamp && (
        <Text fontSize="small" color="white" mt="4">
          Last Updated: {moment(timeStamp).format('MM/DD/YYYY hh:mm A')}
        </Text>
      )}
      {buttonText && onClick && (
        <Button
          variant="link"
          variantColor="success"
          rightIcon="far fa-external-link-square-alt"
          size="small"
          mt="12"
          onClick={onClick}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};
